<template>
  <v-container fluid>
    <v-row
      :class="
        $store.state.isMobile
          ? 'actions align-center'
          : 'actions align-center flex-row-reverse'
      "
      :justify="$store.state.isMobile ? 'start' : 'space-between'"
    >
      <v-col class="back-arrow" cols="auto">
        <v-btn
          variant="text"
          class="ma-0"
          density="compact"
          :icon="$store.state.isMobile ? 'mdi-chevron-left' : 'mdi-close'"
          @click="this.$emit('update:modelValue', false)"
          :disabled="loading"
        >
        </v-btn>
      </v-col>
      <v-col class="task-add" cols="auto">
        <h3>Настройки</h3>
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col :cols="$store.state.isMobile ? 'auto' : 6">
        <v-row>
          <v-col>
            <v-sheet border min-height="200" class="pa-4" rounded="xl">
              <v-list-item-subtitle>Аккаунты</v-list-item-subtitle>
              <v-list density="compact" nav color="#10A6F2">
                <v-list-item
                  rounded="xl"
                  nav
                  :value="mailItem"
                  v-for="mailItem in $store.state.mailbox"
                  :key="mailItem.title"
                  @click="handleItemClick(mailItem)"
                  :active="selectNav[0] === mailItem"
                  :disabled="loading"
                >
                  <template v-slot:prepend>
                    <v-icon class="mr-2"
                      ><svg
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M31.96 17.3542C31.96 16.2492 31.8608 15.1867 31.6767 14.1667H17V20.2017H25.3867C25.0183 22.1425 23.9133 23.7858 22.2558 24.8908V28.815H27.3133C30.26 26.095 31.96 22.1 31.96 17.3542Z"
                          fill="#4285F4"
                        />
                        <path
                          d="M17 32.5833C21.2075 32.5833 24.735 31.195 27.3133 28.815L22.2558 24.8908C20.8675 25.8258 19.0967 26.3925 17 26.3925C12.9483 26.3925 9.50583 23.6583 8.27333 19.975H3.08833V23.9983C5.6525 29.0842 10.9083 32.5833 17 32.5833Z"
                          fill="#34A853"
                        />
                        <path
                          d="M8.27333 19.9608C7.96166 19.0258 7.7775 18.0342 7.7775 17C7.7775 15.9658 7.96166 14.9742 8.27333 14.0392V10.0158H3.08833C2.02583 12.1125 1.41666 14.4783 1.41666 17C1.41666 19.5217 2.02583 21.8875 3.08833 23.9842L7.12583 20.8392L8.27333 19.9608Z"
                          fill="#FBBC05"
                        />
                        <path
                          d="M17 7.62166C19.295 7.62166 21.335 8.41499 22.9642 9.94499L27.4267 5.48249C24.7208 2.96082 21.2075 1.41666 17 1.41666C10.9083 1.41666 5.6525 4.91582 3.08833 10.0158L8.27333 14.0392C9.50583 10.3558 12.9483 7.62166 17 7.62166Z"
                          fill="#EA4335"
                        />
                      </svg>
                    </v-icon>
                    {{ mailItem.title }}
                  </template>
                </v-list-item>
                <v-list-item @click="addMailBox" rounded="xl">
                  <template v-slot:prepend>
                    <v-icon icon="mdi-plus" color="blue" class="mr-2"> </v-icon>
                    Добавить учетную запись
                  </template>
                </v-list-item>
              </v-list>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-sheet border min-height="100" class="pa-4" rounded="xl">
              <v-list-item-subtitle>Общее</v-list-item-subtitle>
              <v-list-item
                @click="console.log('add acc')"
                rounded="xl"
                :disabled="loading"
              >
                <template v-slot:prepend>
                  <v-icon class="mr-2">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.9997 11.3246C11.1846 11.3246 10.6412 11.868 10.6412 12.6831C10.6412 13.2265 11.0488 13.634 11.4563 13.7699L11.0488 15.6718H12.8148L12.4073 13.7699C12.9507 13.634 13.2224 13.2265 13.2224 12.6831C13.3582 11.868 12.8148 11.3246 11.9997 11.3246ZM12.1356 5.48304C11.1846 5.48304 10.2337 6.16229 10.2337 7.11324V9.15098H13.9016V7.11324C13.7658 6.16229 13.0865 5.48304 12.1356 5.48304ZM11.9997 1L2.49023 5.07549V9.15098C2.62608 15.1284 6.42987 20.4265 11.9997 22.6001C17.5695 20.4265 21.3733 15.1284 21.5092 9.15098V5.07549L11.9997 1ZM17.4337 15.9435C17.4337 16.7586 16.8903 17.302 16.0752 17.302H7.92422C7.10912 17.302 6.56572 16.7586 6.56572 15.9435V10.5095C6.56572 9.69438 7.10912 9.15098 7.92422 9.15098H8.33177V7.11324C8.46762 5.21134 10.0978 3.71699 11.9997 3.71699C13.9016 3.71699 15.5318 5.21134 15.6677 7.11324V9.15098H16.0752C16.8903 9.15098 17.4337 9.69438 17.4337 10.5095V15.9435Z"
                        fill="#A6ACB5"
                      />
                    </svg>
                  </v-icon>
                  Параметры конфиденциальности
                </template>
              </v-list-item>
              <v-list-item
                @click="console.log('add acc')"
                rounded="xl"
                :disabled="loading"
              >
                <template v-slot:prepend>
                  <v-icon icon="mdi-help-circle" class="mr-2"> </v-icon>
                  Свяжитесь с нами
                </template>
              </v-list-item>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" v-if="accauntEdit && !$store.state.isMobile">
        <div>
          <v-sheet
            border
            rounded="xl"
            min-height="200"
            class="pa-4 mb-4"
            style="align-content: center"
          >
            <v-row justify="start" align="center">
              <v-col cols="2">
                <svg
                  width="63"
                  height="62"
                  viewBox="0 0 63 62"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="0.5" width="62" height="62" rx="31" fill="#F7F7F9" />
                  <path
                    d="M50.9857 31.4597C50.9857 30.0205 50.8566 28.6365 50.6167 27.308H31.5V35.1687H42.4238C41.944 37.6966 40.5048 39.8371 38.3458 41.2764V46.3877H44.9333C48.7714 42.8449 50.9857 37.6413 50.9857 31.4597Z"
                    fill="#4285F4"
                  />
                  <path
                    d="M31.5001 51.2954C36.9805 51.2954 41.5751 49.4871 44.9335 46.3871L38.346 41.2757C36.5376 42.4936 34.2311 43.2317 31.5001 43.2317C26.2227 43.2317 21.7388 39.6704 20.1335 34.8728H13.3799V40.1132C16.7198 46.7377 23.5656 51.2954 31.5001 51.2954Z"
                    fill="#34A853"
                  />
                  <path
                    d="M20.1336 34.8562C19.7276 33.6383 19.4878 32.3467 19.4878 30.9996C19.4878 29.6526 19.7276 28.361 20.1336 27.1431V21.9026H13.38C11.9961 24.6336 11.2026 27.7151 11.2026 30.9996C11.2026 34.2842 11.9961 37.3657 13.38 40.0967L18.6389 36.0002L20.1336 34.8562Z"
                    fill="#FBBC05"
                  />
                  <path
                    d="M31.5001 18.7848C34.4894 18.7848 37.1465 19.8182 39.2686 21.811L45.0811 15.9985C41.5567 12.714 36.9805 10.7027 31.5001 10.7027C23.5656 10.7027 16.7198 15.2604 13.3799 21.9033L20.1335 27.1438C21.7388 22.3461 26.2227 18.7848 31.5001 18.7848Z"
                    fill="#EA4335"
                  />
                </svg>
              </v-col>
              <v-col cols="auto" style="align-self: center">
                <v-list-item-title>
                  {{ selectNav[0].title }}
                </v-list-item-title>
              </v-col>
            </v-row>
            <!--<v-row justify="space-between">
              <v-col cols="9">
                <v-list-item-title> Синхронизация эл. почты </v-list-item-title>
                <v-list-item-subtitle>
                  Последняя синхронизация: 21.01.2025 12:02
                </v-list-item-subtitle>
              </v-col>
              <v-col cols="auto">
                <v-switch
                  color="blue"
                  v-model="accTrue"
                  hide-details
                  inset
                ></v-switch>
              </v-col>
            </v-row>-->
          </v-sheet>
          <v-sheet border rounded="xl" class="pa-4">
            <v-row>
              <v-col cols="auto">
                <v-list-item
                  @click="deleteMailBox"
                  color="red"
                  rounded="xl"
                  :disabled="loading"
                >
                  <v-list-item-title style="color: red">
                    <v-icon icon="mdi-trash-can"></v-icon>
                    Удалить учетную запись
                  </v-list-item-title>
                </v-list-item>
              </v-col>
            </v-row>
          </v-sheet>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="accauntEdit" fullscreen v-if="$store.state.isMobile">
      <v-card
        class="pa-4"
        v-touch="{
          right: () => (accauntEdit = false),
        }"
      >
        <template class="d-flex actions align-center mb-4" justify="start">
          <v-btn
            variant="text"
            class="ma-0 mr-4"
            density="compact"
            icon="mdi-chevron-left"
            @click="accauntEdit = false"
            :disabled="loading"
          >
          </v-btn>

          <h3>{{ selectNav[0].title }}</h3>
        </template>
        <v-sheet border rounded="xl" min-height="200" class="pa-4 mb-4">
          <v-row justify="center">
            <v-col cols="3">
              <svg
                width="63"
                height="62"
                viewBox="0 0 63 62"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="0.5" width="62" height="62" rx="31" fill="#F7F7F9" />
                <path
                  d="M50.9857 31.4597C50.9857 30.0205 50.8566 28.6365 50.6167 27.308H31.5V35.1687H42.4238C41.944 37.6966 40.5048 39.8371 38.3458 41.2764V46.3877H44.9333C48.7714 42.8449 50.9857 37.6413 50.9857 31.4597Z"
                  fill="#4285F4"
                />
                <path
                  d="M31.5001 51.2954C36.9805 51.2954 41.5751 49.4871 44.9335 46.3871L38.346 41.2757C36.5376 42.4936 34.2311 43.2317 31.5001 43.2317C26.2227 43.2317 21.7388 39.6704 20.1335 34.8728H13.3799V40.1132C16.7198 46.7377 23.5656 51.2954 31.5001 51.2954Z"
                  fill="#34A853"
                />
                <path
                  d="M20.1336 34.8562C19.7276 33.6383 19.4878 32.3467 19.4878 30.9996C19.4878 29.6526 19.7276 28.361 20.1336 27.1431V21.9026H13.38C11.9961 24.6336 11.2026 27.7151 11.2026 30.9996C11.2026 34.2842 11.9961 37.3657 13.38 40.0967L18.6389 36.0002L20.1336 34.8562Z"
                  fill="#FBBC05"
                />
                <path
                  d="M31.5001 18.7848C34.4894 18.7848 37.1465 19.8182 39.2686 21.811L45.0811 15.9985C41.5567 12.714 36.9805 10.7027 31.5001 10.7027C23.5656 10.7027 16.7198 15.2604 13.3799 21.9033L20.1335 27.1438C21.7388 22.3461 26.2227 18.7848 31.5001 18.7848Z"
                  fill="#EA4335"
                />
              </svg>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="5">
              <v-list-item-title> {{ selectNav[0].title }} </v-list-item-title>
            </v-col>
          </v-row>
        </v-sheet>
        <!--<v-sheet border rounded="xl" class="pa-4 mb-4">
          <v-row justify="space-between">
            <v-col cols="9">
              <v-list-item-title> Синхронизация эл. почты </v-list-item-title>
              <v-list-item-subtitle>
                Последняя синхронизация: 21.01.2025 12:02
              </v-list-item-subtitle>
            </v-col>
            <v-col cols="auto">
              <v-switch
                color="blue"
                v-model="accTrue"
                hide-details
                inset
              ></v-switch>
            </v-col>
          </v-row>
        </v-sheet>-->
        <v-sheet border rounded="xl" class="pa-4">
          <v-row>
            <v-col cols="auto">
              <v-list-item
                @click="deleteMailBox"
                color="red"
                rounded="xl"
                :disabled="loading"
              >
                <v-list-item-title style="color: red">
                  <v-icon icon="mdi-trash-can"></v-icon>
                  Удалить учетную запись
                </v-list-item-title>
              </v-list-item>
            </v-col>
          </v-row>
        </v-sheet>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "Setting-component",
  props: {
    modelValue: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      loading: false,
      selectNav: [],
      accauntEdit: false,
      accTrue: true,
    };
  },
  methods: {
    handleItemClick(item) {
      // Если кликнули на уже выбранный элемент, ничего не делаем
      if (this.selectNav[0] === item) {
        return;
      }
      // Иначе обновляем выбранный элемент
      this.selectNav = [item];
      this.accauntEdit = true;
    },
    deleteMailBox() {
      this.loading = true;
      const index = this.$store.state.mailbox.findIndex(
        (e) => e.title == this.selectNav[0].title
      );
      const indexSetting = this.$store.state.mailboxSetting.findIndex(
        (e) => e.title == this.selectNav[0].title
      );

      this.$store.commit("deleteBox", index);
      this.$store.commit("deleteMailboxSetting", indexSetting);

      if (this.$store.state.mailboxSetting.length > 0) {
        this.$emit("update:modelValue", false);
        this.$emit("deleteSetting", this.$store.state.mailbox[0]);
      } else {
        this.$store.commit("setAuth", false);
      }

      localStorage.removeItem("imapSettings");
      if (this.$store.state.mailboxSetting.length > 0) {
        const formDataString = JSON.stringify(this.$store.state.mailboxSetting);
        localStorage.setItem("imapSettings", formDataString);
      }
      this.loading = false;
    },
    addMailBox() {
      this.$store.commit("setAuth", false);
      this.$store.commit("setNewBox", true);
    },
  },
};
</script>
